
import * as s3Runtime$DMM7G2mKPv from '/mnt/scratch/pathwaytester/.jenkins/workspace/website_develop/public/website3/providers/s3.ts'
import * as ipxStaticRuntime$yrVPeyHgFJ from '/mnt/scratch/pathwaytester/.jenkins/workspace/website_develop/public/website3/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['s3']: { provider: s3Runtime$DMM7G2mKPv, defaults: {"baseURL":"https://d14l3brkh44201.cloudfront.net"} },
  ['ipxStatic']: { provider: ipxStaticRuntime$yrVPeyHgFJ, defaults: {} }
}
        